export default __webpack_public_path__ + "static/media/test36nameless.01.cb98d895.png";